import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data.user);
        // Clean fragment
        window.history.replaceState({}, document.title, "/");
        nav("/", { replace: true, state: { user: data.user } });
      } catch (e) {
        nav("/login?error=oauth");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24 font-mono text-xs text-white/50">
      Signing you in…
    </div>
  );
}
